import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { SvgIcon, useTheme, AppBar, Toolbar, Box, Typography, IconButton, useMediaQuery, Stack, Grid, Link } from "@mui/material";
import { useState } from "react";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { MBLogo as MBLogo$1 } from "@mercedes-benz/mbui-comps";
import { ThemeTypography, grey } from "@mercedes-benz/mui5-theme";
const MBLogo = (props) => {
  return /* @__PURE__ */ jsxs(SvgIcon, {
    ...props,
    viewBox: "0 0 64 64",
    children: [/* @__PURE__ */ jsxs("linearGradient", {
      id: "a",
      x1: "114",
      x2: "162",
      y1: "-142.9",
      y2: "-183.1",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#FFF"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".1",
        stopColor: "#E7E8E6"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".1",
        stopColor: "#CDD0D0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".2",
        stopColor: "#B5BBBD"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".2",
        stopColor: "#A5ACAF"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".3",
        stopColor: "#9BA3A7"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".3",
        stopColor: "#98A0A4"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".4",
        stopColor: "#828A8F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".5",
        stopColor: "#667075"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".6",
        stopColor: "#535C63"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#475158"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#434D54"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#475157"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#a)",
      d: "M63.3 32c0 17.3-14 31.3-31.3 31.3S.7 49.3.7 32 14.7.7 32 .7s31.3 14 31.3 31.3zM32 2.6C15.7 2.6 2.6 15.7 2.6 32S15.8 61.4 32 61.4c16.3 0 29.4-13.2 29.4-29.4C61.4 15.7 48.3 2.6 32 2.6z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "b",
      x1: "115.47",
      x2: "160.47",
      y1: "-144.06",
      y2: "-181.86",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#0B1F2A"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".2",
        stopColor: "#333F47"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".5",
        stopColor: "#777F84"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".5",
        stopColor: "#81898D"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#B3B8B8"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#D2D5D3"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#DEE0DD"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#FBFBFB"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#b)",
      d: "M32 2.6C15.7 2.6 2.6 15.7 2.6 32S15.8 61.4 32 61.4c16.3 0 29.4-13.2 29.4-29.4C61.4 15.7 48.3 2.6 32 2.6zm0 56.9C16.8 59.5 4.5 47.2 4.5 32S16.8 4.5 32 4.5 59.5 16.8 59.5 32 47.2 59.5 32 59.5z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "c",
      x1: "1933.73",
      x2: "1955.63",
      y1: "-176.94",
      y2: "-237.14",
      gradientTransform: "matrix(-1 0 0 1 1976.672 239.007)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#E1E3E1"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".1",
        stopColor: "#C1C5C4"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".3",
        stopColor: "#9BA1A2"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".5",
        stopColor: "#7D8487"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#687074",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#5b6469",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#576065",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#c)",
      d: "M32 63.3c17.3 0 31.3-14 31.3-31.3S49.3.7 32 .7.7 14.7.7 32s14 31.3 31.3 31.3zM32 0c17.6 0 32 14.4 32 32S49.6 64 32 64 0 49.6 0 32 14.4 0 32 0z",
      opacity: ".4"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#FFF",
      d: "M2.2 32.1C2.2 15.7 15.5 2.2 32 2.2s29.8 13.4 29.8 29.9c0 16.4-13.3 29.7-29.8 29.7S2.2 48.5 2.2 32.1zm9.3-20.6c-5.3 5.3-8.6 12.6-8.6 20.6 0 8 3.3 15.3 8.5 20.5 5.3 5.2 12.6 8.5 20.6 8.5 8 0 15.3-3.2 20.5-8.5 5.3-5.2 8.5-12.5 8.5-20.5s-3.3-15.3-8.5-20.6C47.3 6.2 40 2.9 32 2.9s-15.3 3.3-20.5 8.6z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "d",
      x1: "124.2",
      x2: "151.8",
      y1: "-139.1",
      y2: "-186.9",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#E1E3E1"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".1",
        stopColor: "#C1C5C4"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".3",
        stopColor: "#9BA1A2"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".5",
        stopColor: "#7D8487"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#687074",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#5b6469",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#576065",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#d)",
      d: "M32 59.6c-7.4 0-14.3-2.9-19.5-8.1S4.4 39.4 4.4 32s2.9-14.3 8.1-19.5S24.6 4.4 32 4.4s14.3 2.9 19.5 8.1 8.1 12.1 8.1 19.5-2.9 14.3-8.1 19.5-12.1 8.1-19.5 8.1zm0-.8c7.1 0 13.9-2.8 18.9-7.8 5.1-5.1 7.8-11.8 7.8-18.9s-2.8-13.9-7.8-18.9C45.8 8.1 39.1 5.4 32 5.4c-7.1 0-13.9 2.8-18.9 7.8C8 18.1 5.2 24.9 5.2 32c0 7.1 2.8 13.9 7.8 18.9 5.1 5.1 11.9 7.9 19 7.9z",
      opacity: ".4"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#FFF",
      d: "M56.3 45c-.5-.4-19.8-15.7-19.8-15.7L32 3.6c-.3.1-.7.4-.9.8l-3.2 25L8 44.7s-.4.5-.6.8c-.1.2-.1.5-.1.8l24.6-10.1 24.6 10.1c.2-.5 0-1-.2-1.3z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#565F64",
      d: "m32.2 32.8-.2 4.6 22.6 9.1c.8.4 1.4.2 2-.2L32.5 32.7c-.1-.1-.3 0-.3.1z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "e",
      x1: "150.49",
      x2: "148.79",
      y1: "-170.39",
      y2: "-173.19",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#27343C"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#00111e",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#e)",
      d: "M32.2 32.8s1.3 2.3 2.8 3.9c2.1 2.3 4.9 3.9 4.9 3.9l14.7 5.9c.8.4 1.4.2 2-.2L32.5 32.7c-.1-.1-.3 0-.3.1z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#A4AAAE",
      fillOpacity: ".6",
      d: "M56.5 45.4c0-.1-.1-.2-.2-.4L35.7 29.9l-2.8 1.8s.2.1.3 0c.3-.1.9-.2 1.5 0 .5.2 21.8 13.8 21.8 13.8v-.1z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#333E46",
      d: "M55.8 44.5 36.6 29.3l-.9.6 20.6 15.2c-.1-.2-.3-.4-.5-.6z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#565F64",
      d: "m32.5 31.3-.1.1s0 .2.2.1c.1-.1 3-1.6 4-2.2l-3.5-24c-.1-.9-.5-1.3-1.2-1.6l.4 27.8.2-.2z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#A4AAAE",
      fillOpacity: ".6",
      d: "M30.8 5.3v1.3l-2.2 22.1c0 .3.1.6.4.8l1.3 1 .9-24.4.1-1.9c-.3.2-.4.6-.5 1.1zm-1.2 25.6-1.2-1L8.1 44.6s-.6.4-.7.8l.7-.4 21.3-13.4c.4-.2.5-.4.2-.7z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#565F64",
      d: "M31.7 32.8c0-.1-.1-.2-.2-.1L7.3 46.4c.6.4 1.2.5 2 .2l22.6-9.1-.2-4.7z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "f",
      x1: "145.58",
      x2: "142.78",
      y1: "-160.11",
      y2: "-155.61",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: ".1",
        stopColor: "#02131F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".9",
        stopColor: "#02131f",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#f)",
      d: "m32.4 31.4.1-.1-.1.1s0 .1.1.1h.1c.1-.1 3-1.6 4-2.2l-.4-2.9-3.1-21.1c0-.4-.1-.7-.3-.9 0 0 1.5 20.2 1.5 22.4 0 2.9-1.9 4.6-1.9 4.6z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "g",
      x1: "137.98",
      x2: "133.78",
      y1: "-167.34",
      y2: "-168.54",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: ".2",
        stopColor: "#02131F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".9",
        stopColor: "#02131f",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#g)",
      fillOpacity: ".8",
      d: "M31.7 32.8c0-.1-.1-.2-.2-.1L7.3 46.4c.6.4 1.2.5 2 .2l22.6-9.1-.2-4.7z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "h",
      x1: "126.79",
      x2: "126.19",
      y1: "-172.9",
      y2: "-171.4",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#02131F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".1",
        stopColor: "#02131F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#02131f",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#h)",
      d: "m9.3 46.5 22.6-9.1-.2-4.4c-.4 1.2-1.1 2.5-3 3.5-1.4.8-14.8 7.4-19.6 9.7-.3.2-.7.3-.9.4.4.2.7.1 1.1-.1z",
      opacity: ".8"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "i",
      x1: "141.6",
      x2: "138.2",
      y1: "-148.21",
      y2: "-148.61",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: ".3",
        stopColor: "#02131F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".3",
        stopColor: "#02131F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#02131f",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#i)",
      d: "m32.5 31.3-.1.1s0 .2.2.1c.1-.1 3-1.6 4-2.2l-3.5-24c-.1-.9-.5-1.3-1.2-1.6l.4 27.8.2-.2z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "j",
      x1: "141.71",
      x2: "139.41",
      y1: "-148.16",
      y2: "-148.46",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: ".4",
        stopColor: "#27343C"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#3b474e",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#j)",
      d: "m32.5 31.3-.1.1s0 .2.2.1c.1-.1 3-1.6 4-2.2l-3.5-24c-.1-.9-.5-1.3-1.2-1.6l.4 27.8.2-.2z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "k",
      x1: "105.64",
      x2: "133.54",
      y1: "-163.83",
      y2: "-179.93",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#24303a",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#25323b",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".1",
        stopColor: "#27343C"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#k)",
      d: "M5.1 44.4C4.4 42.8.4 35 4.8 20H3.1c-.9 3-1.6 4.8-2 7.5 0 0-.2 1-.3 2.1C.7 30.7.7 31.3.7 32c0 6 1.5 9.5 1.5 9.5 1.6 5 4.4 9.5 8.2 12.9 3.3 2.9 8.4 5.1 12.6 5.9-.7-.1-12.7-5.2-17.9-15.9z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "l",
      x1: "137.95",
      x2: "137.95",
      y1: "-168.4",
      y2: "-163.6",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: ".3",
        stopColor: "#A5ABAF"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#a5abaf",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#l)",
      d: "M32.4 32.6h-.9c.1 0 .2 0 .2.1l.2 4.6h.1l.2-4.6c0-.1.1-.2.2-.1z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "m",
      x1: "153.65",
      x2: "153.65",
      y1: "-133.3",
      y2: "-194.3",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#DEE0DD"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#C5C9C7"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#9EA4A5"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#82898C"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#71797D"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#6B7378"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".2",
        stopColor: "#333F47"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".5",
        stopColor: "#27343C"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#333F47"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#434D54"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#m)",
      d: "M42 2.3c10.5 4 20.4 15 20.4 28.9C62.4 48 49 61.7 32 61.7v1.6c17 0 31.3-14 31.3-31.3 0-13.8-8.8-25.4-21.3-29.7z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "n",
      x1: "138",
      x2: "138.3",
      y1: "-131.7",
      y2: "-131.7",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#DEE0DD"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#C5C9C7"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#9EA4A5"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#82898C"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#71797D"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#6B7378"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".2",
        stopColor: "#333F47"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".5",
        stopColor: "#27343C"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#333F47"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#434D54"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#n)",
      d: "M32.3.7H32h.3z"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "o",
      x1: "163.29",
      x2: "149.79",
      y1: "-139.09",
      y2: "-158.89",
      gradientTransform: "matrix(1 0 0 -1 -106 -131)",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#27343C"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#2B373F"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#36424A"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".7",
        stopColor: "#49545B"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#646d73",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#868d92",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#b0b5b8",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#e1e3e4",
        stopOpacity: "0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: ".8",
        stopColor: "#fff",
        stopOpacity: "0"
      })]
    }), /* @__PURE__ */ jsx("path", {
      fill: "url(#o)",
      d: "M58.8 20.2C51.8 4.1 36 3.2 35.1 3.1H35c12.1 2.2 19.8 10.1 22.5 18.4v.1c1.2 3.2 1.8 6.6 1.9 10.3.1 3.5-.7 7.4-2.2 11-.1.5-.2 1.1-.3 1.1h1.6c4.8-9 2.7-18.1.3-23.8z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#FBFBFB",
      d: "M2.2 32.1C2.2 15.7 15.5 2.2 32 2.2s29.8 13.4 29.8 29.9c0 16.4-13.3 29.7-29.8 29.7S2.2 48.5 2.2 32.1zm9.3-20.6c-5.3 5.3-8.6 12.6-8.6 20.6 0 8 3.3 15.3 8.5 20.5 5.3 5.2 12.6 8.5 20.6 8.5 8 0 15.3-3.2 20.5-8.5 5.3-5.2 8.5-12.5 8.5-20.5s-3.3-15.3-8.5-20.6C47.3 6.2 40 2.9 32 2.9s-15.3 3.3-20.5 8.6z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "#333F47",
      d: "m7.9 44.8 20.4-14.7c1.1.6 2.9 1.4 3.1 1.4.2.1.2-.1.2-.1l-2.5-2.1c-.3-.2-.4-.5-.4-.8l2.4-24.1c-.1.1-.1.3-.2.4-.1.2-.1.3-.1.5l-3.5 24.1L8.1 44.5c-.1.1-.2.2-.2.3z"
    })]
  });
};
const MBAppBar = ({
  leftContent,
  rightContent,
  hideLogo = false,
  logoOnClick = null,
  showInformationClassification = false,
  informationClassification,
  logoShowUpBreakpoint = "md",
  position = "static"
}) => {
  const [isHidden, setHidden] = useState(localStorage.getItem("classification") === "true");
  const click = async () => {
    setHidden(true);
    localStorage.setItem("classification", "true");
  };
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(AppBar, {
    position,
    enableColorOnDark: true,
    sx: (theme2) => ({
      backgroundColor: theme2.palette.common.black,
      backgroundImage: "none"
    }),
    children: [/* @__PURE__ */ jsxs(Toolbar, {
      sx: {
        display: "flex"
      },
      children: [/* @__PURE__ */ jsx(Box, {
        flex: 1,
        children: leftContent
      }), !hideLogo && /* @__PURE__ */ jsx(Box, {
        sx: {
          flex: 0,
          width: 42,
          height: 42,
          display: "flex",
          justifyContent: "center",
          ...logoOnClick ? {
            cursor: "pointer"
          } : {}
        },
        ...logoOnClick ? {
          onClick: logoOnClick
        } : {},
        children: /* @__PURE__ */ jsx(MBLogo, {
          sx: (theme2) => ({
            height: "100%",
            width: "auto",
            display: "none",
            [theme2.breakpoints.up(logoShowUpBreakpoint)]: {
              display: "block"
            }
          })
        })
      }), /* @__PURE__ */ jsx(Box, {
        flex: 1,
        children: rightContent
      })]
    }), showInformationClassification && !isHidden && /* @__PURE__ */ jsxs(Toolbar, {
      sx: {
        display: "flex",
        justifyContent: "end",
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default
      },
      variant: "dense",
      children: [/* @__PURE__ */ jsx(Typography, {
        fontWeight: "bold",
        px: 1,
        py: 0.5,
        borderRadius: 2,
        border: 1,
        children: informationClassification
      }), informationClassification !== "secret" && /* @__PURE__ */ jsx(IconButton, {
        onClick: click,
        "aria-label": "close",
        children: /* @__PURE__ */ jsx(HighlightOffIcon, {})
      })]
    })]
  });
};
const MBFooter = ({
  leftContent,
  rightContent,
  rightsReservedText = "\xA9 2023 Mercedes-Benz Group AG. All rights reserved.",
  privacyProtectionInfoLink,
  legalNoticeInfoLink,
  providerInfoLink,
  cookieInfoLink,
  thirdPartyLicenseInfoLink,
  lang = "en"
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsxs(AppBar, {
    component: "footer",
    position: "relative",
    enableColorOnDark: true,
    sx: (theme2) => ({
      backgroundColor: theme2.palette.common.black,
      backgroundImage: "none"
    }),
    children: [/* @__PURE__ */ jsxs(Stack, {
      paddingX: 2,
      paddingY: 2.5,
      direction: isMobile ? "column" : "row",
      children: [/* @__PURE__ */ jsxs(Stack, {
        direction: "row",
        children: [/* @__PURE__ */ jsx(Box, {
          sx: {
            flex: 0,
            width: 40,
            height: 40,
            marginRight: 5,
            display: "flex",
            justifyContent: "center"
          },
          children: /* @__PURE__ */ jsx(MBLogo$1, {
            sx: {
              height: "100%",
              width: "auto"
            }
          })
        }), /* @__PURE__ */ jsx(Box, {
          sx: {
            height: "40px"
          },
          marginLeft: {
            xs: "auto",
            md: 0
          },
          children: /* @__PURE__ */ jsx(Typography, {
            variant: "body1",
            fontFamily: ThemeTypography.fontFamilyCorpoATitle,
            display: "flex",
            alignItems: "end",
            sx: (theme2) => ({
              color: theme2.palette.common.white
            }),
            children: "Mercedes-Benz"
          })
        })]
      }), (leftContent || rightContent) && /* @__PURE__ */ jsxs(Stack, {
        direction: "row",
        alignItems: "center",
        flexGrow: 1,
        mt: {
          xs: 2.5,
          md: 0
        },
        ml: {
          xs: 0,
          md: 5
        },
        children: [leftContent && /* @__PURE__ */ jsx(Box, {
          flex: 1,
          children: leftContent
        }), rightContent && /* @__PURE__ */ jsx(Box, {
          flex: 1,
          children: rightContent
        })]
      })]
    }), /* @__PURE__ */ jsxs(Stack, {
      direction: isMobile ? "column" : "row",
      padding: 2,
      spacing: 2,
      justifyContent: "space-between",
      sx: (theme2) => ({
        backgroundColor: theme2.palette.background.paper,
        color: theme2.palette.text.primary,
        borderTop: "1px solid" + grey[30]
      }),
      alignItems: "center",
      children: [/* @__PURE__ */ jsx(Box, {
        flex: "0 0 auto",
        children: /* @__PURE__ */ jsx(Typography, {
          variant: "body2",
          children: rightsReservedText
        })
      }), /* @__PURE__ */ jsx(Box, {
        width: {
          xs: "100%",
          md: "auto"
        },
        children: /* @__PURE__ */ jsxs(Grid, {
          container: true,
          columnSpacing: {
            md: 2
          },
          rowSpacing: {
            xs: 1,
            md: 0
          },
          children: [cookieInfoLink && /* @__PURE__ */ jsx(Grid, {
            item: true,
            xs: 6,
            md: "auto",
            children: /* @__PURE__ */ jsx(Link, {
              variant: "body2",
              underline: "hover",
              color: "secondary",
              href: cookieInfoLink,
              children: "Cookies"
            })
          }), thirdPartyLicenseInfoLink && /* @__PURE__ */ jsx(Grid, {
            item: true,
            xs: 6,
            md: "auto",
            children: /* @__PURE__ */ jsx(Link, {
              variant: "body2",
              underline: "hover",
              color: "secondary",
              href: thirdPartyLicenseInfoLink,
              children: lang === "de" ? "Lizenzhinweise Dritter" : "Third Party License Notes"
            })
          }), /* @__PURE__ */ jsx(Grid, {
            item: true,
            xs: 6,
            md: "auto",
            children: /* @__PURE__ */ jsx(Link, {
              variant: "body2",
              underline: "hover",
              color: "secondary",
              href: privacyProtectionInfoLink,
              children: lang === "de" ? "Datenschutz" : "Privacy Statement"
            })
          }), /* @__PURE__ */ jsx(Grid, {
            item: true,
            xs: 6,
            md: "auto",
            children: /* @__PURE__ */ jsx(Link, {
              variant: "body2",
              underline: "hover",
              color: "secondary",
              href: legalNoticeInfoLink,
              children: lang === "de" ? "Rechtliche Hinweise" : "Legal Notice"
            })
          }), /* @__PURE__ */ jsx(Grid, {
            item: true,
            xs: 6,
            md: "auto",
            children: /* @__PURE__ */ jsx(Link, {
              variant: "body2",
              underline: "hover",
              color: "secondary",
              href: providerInfoLink,
              children: lang === "de" ? "Anbieter" : "Provider"
            })
          })]
        })
      })]
    })]
  });
};
const MBIrgendwas = ({}) => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("h1", {
      children: "MB Irgendwas"
    })
  });
};
export { MBAppBar, MBFooter, MBIrgendwas, MBLogo };
